import { Component } from '@angular/core';

import { DocumentFinderService } from '~/services/document-finder.service';

const LAND_LABELS = { both: 'As-Is + To-Be', asis: 'As-Is (ECC)', tobe: 'To-Be (S/4HANA)' };

@Component({
    selector: 'df-scope-chips',
    template: `
    <div class="chips">
      <div class="chip">LANDSCAPE<b>{{ landLabel }}</b></div>
      <div class="chip">SOURCES<b>{{ df.scope.src.size }}</b></div>
      <div class="chip" *ngIf="df.step >= 3">DOCUMENTS FOUND<b>{{ df.found().length }}</b></div>
    </div>`,
    styleUrls: ['./df-scope-chips.component.scss'],
    standalone: false
})
export class DfScopeChipsComponent {
    constructor(public df: DocumentFinderService) {}

    public get landLabel(): string {
        return LAND_LABELS[this.df.scope.land];
    }
}
